module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-list', {
    staticClass: "md-double-line"
  }, _vm._l((_vm.events), function(event, index) {
    return ((event.dateTime > new Date()) || (new Date() - new Date(event.date) <= 86400000)) ? _c('md-list-item', {
      key: index
    }, [_c('div', {
      staticClass: "md-list-text-container"
    }, [_c('span', [_c('router-link', {
      attrs: {
        "to": {
          name: 'Event',
          params: {
            eventId: event.id
          }
        }
      }
    }, [_vm._v("\n            " + _vm._s(event.name) + "\n          ")])], 1), _vm._v(" "), _c('span', {
      staticClass: "jpCaption"
    }, [_vm._v("\n          " + _vm._s(event.host) + "\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          " + _vm._s(_vm.getEventSchedule(event.startTime, event.endTime)) + "\n        ")])]), _vm._v(" "), (event.type === 'Class') ? _c('md-chip', {
      key: "eventClass",
      staticClass: "md-primary"
    }, [_vm._v("クラス")]) : (event.type === 'Céilí') ? _c('md-chip', {
      key: "eventCeili",
      staticClass: "md-accent"
    }, [_vm._v("ケーリー")]) : (event.type === 'SessionOrDance') ? _c('md-chip', {
      key: "evnetCeili",
      staticClass: "md-primary"
    }, [_vm._v("セッション/ダンス")]) : _vm._e(), _vm._v(" "), _c('md-divider')], 1) : _vm._e()
  })), _vm._v(" "), _c('md-divider'), _vm._v(" "), _c('div', {
    staticClass: "event-controller"
  }, [_c('router-link', {
    staticClass: "md-raised",
    attrs: {
      "tag": "md-button",
      "to": {
        name: 'AllEvent'
      }
    }
  }, [_vm._v("過去のイベントをみる")]), _vm._v(" "), _c('router-link', {
    staticClass: "md-raised md-primary",
    attrs: {
      "tag": "md-button",
      "to": {
        name: 'AddEvent'
      }
    }
  }, [_vm._v("イベントを作成する")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79bce237","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NextEvents.vue
// module id = 338
// module chunks = 1